module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "botmBtnContainer"
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.print();
      }
    }
  }, [_vm._v("打印本页")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    },
    on: {
      "click": _vm.exportWord
    }
  }, [_vm._v("导出word")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content",
    attrs: {
      "id": "pagecontent"
    }
  }, [_c('table', {
    staticClass: "toptable",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "border": "0"
    }
  }, [_c('tr', [_c('td', [_c('h1', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.companyInfo.companyName)), _c('br'), _vm._v(" "), _c('samp', [_vm._v("\n\t\t\t\t\t\t\t电话：" + _vm._s(_vm.companyInfo.tel) + "\n\t\t\t\t\t\t\t传真：" + _vm._s(_vm.companyInfo.fax)), _c('br'), _vm._v(" "), (_vm.companyInfo.adress) ? _c('span', [_vm._v("地址：" + _vm._s(_vm.companyInfo.adress))]) : _vm._e()])])])])]), _vm._v(" "), _c('div', [_vm._v(" ")]), _vm._v(" "), _c('table', {
    staticClass: "midtable",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "border": "0"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('h2', [_vm._v(_vm._s(_vm.detailData.productName))])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("产品编号")]), _vm._v(" "), _c('td', {
    staticClass: "ninety"
  }, [_vm._v(_vm._s(_vm.detailData.productId))]), _vm._v(" "), _c('th', [_vm._v("出发地")]), _vm._v(" "), _c('td', {
    staticClass: "cityName"
  }, [_vm._v(_vm._s(_vm.detailData.startCity))]), _vm._v(" "), _c('th', [_vm._v("旅游天数")]), _vm._v(" "), _c('td', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.detailData.travelDay))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("出团日期")]), _vm._v(" "), _c('td', {
    staticClass: "ninety"
  }, [_vm._v(_vm._s(_vm.orderInfo && _vm.orderInfo.startDate || ""))]), _vm._v(" "), _c('th', [_vm._v("出发交通")]), _vm._v(" "), _c('td', {
    staticClass: "cityName",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.detailData.goTraffic))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("返程日期")]), _vm._v(" "), _c('td', {
    staticClass: "ninety"
  }, [_vm._v(_vm._s(_vm.orderInfo && _vm.orderInfo.backDay || ""))]), _vm._v(" "), _c('th', [_vm._v("返程交通")]), _vm._v(" "), _c('td', {
    staticClass: "cityName",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.detailData.backTraffic))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("集合时间")]), _vm._v(" "), _c('td', {
    staticClass: "ninety"
  }, [_vm._v(_vm._s(_vm.detailData.collectionTime ? _vm.detailData.collectionTime : ""))]), _vm._v(" "), _c('th', [_vm._v("集合地点")]), _vm._v(" "), _c('td', {
    staticClass: "cityName"
  }, [_vm._v(_vm._s(_vm.detailData.collectionPlace ? _vm.detailData.collectionPlace : ""))]), _vm._v(" "), _c('th', [_vm._v("单房差价")]), _vm._v(" "), _c('td', {
    staticClass: "num"
  }, [_vm._v(_vm._s(_vm.detailData.housePrice ? _vm.detailData.housePrice : 0))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("送团电话")]), _vm._v(" "), _c('td', {
    staticClass: "ninety"
  }, [_vm._v(_vm._s(_vm.detailData.giveTel ? _vm.detailData.giveTel : ""))]), _vm._v(" "), _c('th', [_vm._v("送团标志/人")]), _vm._v(" "), _c('td', {
    staticClass: "num",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.detailData.giveId ? _vm.detailData.giveId : ""))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("产品亮点")]), _vm._v(" "), _c('td', {
    staticClass: "list",
    attrs: {
      "colspan": "5"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.summary || ''))
    }
  })]), _vm._v(" "), _c('tr', {
    staticClass: "faq"
  }, [_c('th', [_vm._v("报名须知")]), _vm._v(" "), _c('td', {
    staticClass: "list",
    attrs: {
      "colspan": "5"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.signUp || ''))
    }
  })]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "6"
    }
  }, [_c('div', {
    staticClass: "price"
  }, [_c('span', [_vm._v("成人价格：")]), _vm._v(" "), _c('b', [_vm._v("¥" + _vm._s(_vm.detailData.adminPrice))]), _vm._v(" "), _c('span', [_vm._v("/人 ")]), _vm._v(" "), _c('span', [_vm._v("小孩价格：")]), _vm._v(" "), _c('b', [_vm._v("¥" + _vm._s(_vm.detailData.childPrice))]), _vm._v(" "), _c('span', [_vm._v("/人 ")])])])])]), _vm._v(" "), _c('div', [_vm._v(" ")]), _vm._v(" "), _c('table', {
    staticClass: "routeinfo",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "border": "0"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.templateList), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "date"
    }, [_vm._v("第" + _vm._s(item.day) + "天")]), _vm._v(" "), _c('td', {
      staticClass: "descript"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.repalce(item.remark || ''))
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "food"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(item.isBreakfast === 0 ? '' : '早餐') + "\n\t\t\t\t\t" + _vm._s(item.isLunch === 0 ? '' : '中餐') + "\n\t\t\t\t\t" + _vm._s(item.isDinner === 0 ? '' : '晚餐') + "\n\t\t\t\t")]), _vm._v(" "), _c('td', {
      staticClass: "hotel"
    }, [_vm._v(_vm._s(item.hotelName))])])
  })], 2), _vm._v(" "), _c('div', [_vm._v(" ")]), _vm._v(" "), _c('table', {
    staticClass: "include",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "border": "0"
    }
  }, [_c('tr', [(_vm.detailData.productDetail && _vm.detailData.productDetail.inclustionItems) ? _c('th', [_vm._v("\n\t\t\t\t\t包含项目\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.productDetail && _vm.detailData.productDetail.inclustionItems) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.inclustionItems || ''))
    }
  }) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.detailData.productDetail && _vm.detailData.productDetail.noInclustionItems) ? _c('th', [_vm._v("\n\t\t\t\t\t不包含项目\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.productDetail && _vm.detailData.productDetail.noInclustionItems) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.noInclustionItems || ''))
    }
  }) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.detailData.productDetail && _vm.detailData.productDetail.childPlan) ? _c('th', [_vm._v("\n\t\t\t\t\t儿童安排\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.productDetail && _vm.detailData.productDetail.childPlan) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.childPlan || ''))
    }
  }) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.detailData.productDetail && _vm.detailData.productDetail.shopPlan) ? _c('th', [_vm._v("\n\t\t\t\t\t购物安排\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.productDetail && _vm.detailData.productDetail.shopPlan) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.shopPlan || ''))
    }
  }) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.detailData.productDetail && _vm.detailData.productDetail.mayPlan) ? _c('th', [_vm._v("\n\t\t\t\t\t可选项目\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.productDetail && _vm.detailData.productDetail.mayPlan) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.mayPlan || ''))
    }
  }) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.detailData.productDetail && _vm.detailData.productDetail.givePlan) ? _c('th', [_vm._v("\n\t\t\t\t\t赠送项目\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.productDetail && _vm.detailData.productDetail.givePlan) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.givePlan || ''))
    }
  }) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.detailData.productDetail && _vm.detailData.productDetail.attentions) ? _c('th', [_vm._v("\n\t\t\t\t\t注意事项\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.productDetail && _vm.detailData.productDetail.attentions) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.attentions || ''))
    }
  }) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.detailData.productDetail && _vm.detailData.productDetail.otherPlan) ? _c('th', [_vm._v("\n\t\t\t\t\t其他事项\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.detailData.productDetail && _vm.detailData.productDetail.otherPlan) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.otherPlan || ''))
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', [_vm._v(" ")]), _vm._v(" "), _c('table', {
    staticClass: "reminder",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "border": "0"
    }
  }, [_c('tr', [(_vm.detailData.productDetail && _vm.detailData.productDetail.reminder) ? _c('th', [_vm._v("温馨提醒")]) : _vm._e(), _vm._v(" "), (_vm.detailData.productDetail && _vm.detailData.productDetail.reminder) ? _c('td', {
    domProps: {
      "innerHTML": _vm._s(_vm.repalce(_vm.detailData.productDetail && _vm.detailData.productDetail.reminder || ''))
    }
  }) : _vm._e()])]), _vm._v("\n\t\t \n\t\t"), _c('table', {
    staticClass: "foot",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "border": "0"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v("操作人：" + _vm._s(_vm.operatorName) + "   打印日期：" + _vm._s(_vm.detailData.currentDate))]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-checkbox', [_vm._v("\n\t\t\t\t\t\t我已阅读行程细则并认可")])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n\t\t\t\t\t签字：\n\t\t\t\t")])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_vm._v("\n\t\t\t\t\t日期：\n\t\t\t\t")])], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th', {
    staticClass: "date"
  }, [_vm._v("日期")]), _vm._v(" "), _c('th', [_vm._v("描述")]), _vm._v(" "), _c('th', {
    staticClass: "food"
  }, [_vm._v("三餐")]), _vm._v(" "), _c('th', {
    staticClass: "hotel"
  }, [_vm._v("住宿")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2be245b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layout/route.vue
// module id = 1230
// module chunks = 2